import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Header.css';

const Header = ({ 
  logo = "Dispetly", 
  navigation = [
    { href: "#domov", label: "Domov" },
    { href: "#ako-to-funguje", label: "Ako to funguje" },
    { href: "/cennik", label: "Cenník" },
    { href: "/dokumentacia", label: "Dokumentácia" },
    { href: "#kontakt", label: "Kontakt" }
  ]
}) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, user, logout } = useAuth();

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      if (scrollTop > lastScrollTop && scrollTop > 100) {
        // Scrolling down
        setIsHidden(true);
      } else {
        // Scrolling up
        setIsHidden(false);
      }
      
      // Add scrolled class for background change
      setIsScrolled(scrollTop > 50);
      setLastScrollTop(scrollTop);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollTop]);

  const handleLogoClick = (e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      // Smooth scroll to top if already on home page
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleNavClick = (e, href) => {
    e.preventDefault();
    
    if (href.startsWith('/')) {
      // External route
      navigate(href);
    } else if (href.startsWith('#')) {
      // Anchor link
      if (location.pathname !== '/') {
        // If not on home page, navigate to home first
        navigate('/');
        setTimeout(() => {
          const element = document.querySelector(href);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      } else {
        // Smooth scroll to section
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  };

  const handleAuthClick = (e) => {
    e.preventDefault();
    if (isAuthenticated) {
      // Go to dashboard
      const dashboardPath = user?.role === 'ADMIN' ? '/admin' : '/driver';
      navigate(dashboardPath);
    } else {
      // Go to login page
      navigate('/auth');
    }
  };

  return (
    <header className={`header ${isHidden ? 'hidden' : ''} ${isScrolled ? 'scrolled' : ''}`}>
      <nav className="nav">
        <a href="/" className="logo" onClick={handleLogoClick}>{logo}</a>
        
        <ul className="nav-links">
          {navigation.map((item, index) => (
            <li key={index}>
              <a href={item.href} onClick={(e) => handleNavClick(e, item.href)}>
                {item.label}
              </a>
            </li>
          ))}
        </ul>
        
        <div className="nav-right">
          {isAuthenticated ? (
            <div className="user-menu">
              <button 
                className="modern-login-btn logged-in"
                onClick={handleAuthClick}
              >
                <svg 
                  width="14" 
                  height="14" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                  className="user-icon"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                  <circle cx="12" cy="7" r="4"/>
                </svg>
                {user?.role === 'ADMIN' ? 'Prihlásený' : 'Prihlásený'}
              </button>
            </div>
          ) : (
            <a 
              href="#" 
              className="modern-login-btn"
              onClick={handleAuthClick}
            >
              <svg 
                width="14" 
                height="14" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
                className="lock-icon"
              >
                <rect width="18" height="11" x="3" y="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
              Prihlásenie
            </a>
          )}
          
          <div className="mobile-menu-toggle">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header; 